import { useEffect, useMemo, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "@/components/Toast";
import { DeletedUserBadge } from "@/components/DeletedUserBadge";
import { ExportButtons } from "@/components/ExportButtons"; // Fix BS

export default function AdminServices() {
  const [list, setList] = useState(null);
  const [clients, setClients] = useState([]);
  const [tab, setTab] = useState("open");

  const load = async () => {
    try {
      const status = tab === "all" ? "" : tab === "open" ? "?status=open" : "?status=closed";
      const [s, c] = await Promise.all([api.get(`/services${status}`), api.get("/clients")]);
      setList(s.data); setClients(c.data);
    } catch (e) { toast.error(formatApiError(e)); }
  };
  useEffect(() => { load(); }, [tab]);

  const close = async (id) => {
    if (!window.confirm("¿Forzar cierre de este servicio?")) return;
    try { await api.post("/services/close", { service_id: id, notes: "Cerrado por admin" }); toast.success("Servicio cerrado"); load(); }
    catch (e) { toast.error(formatApiError(e)); }
  };

  const nameOf = (cid) => clients.find((c) => c.id === cid)?.name || "—";
  const counts = useMemo(() => list ? { open: list.filter((s) => s.status === "open").length, closed: list.filter((s) => s.status === "closed").length } : { open: 0, closed: 0 }, [list]);

  return (
    <div style={{ padding: "20px 24px 60px" }}>
      <div style={{ fontSize: 11, letterSpacing: "0.2em", color: "#BF3437", fontWeight: 700, textTransform: "uppercase" }}>Operación</div>
      <h1 style={{ fontSize: 32, fontWeight: 900, margin: "4px 0 22px", color: "#0A0A0A", letterSpacing: "-0.02em" }}>Servicios</h1>

      <div style={{ display: "flex", gap: 4, marginBottom: 14, borderBottom: "1px solid var(--invict-bone-3)" }}>
        {[
          { k: "open", label: "Abiertos" },
          { k: "closed", label: "Cerrados" },
          { k: "all", label: "Todos" },
        ].map((t) => (
          <button key={t.k} onClick={() => setTab(t.k)}
            style={{ padding: "10px 16px", border: "none", background: "transparent", color: tab === t.k ? "#0A0A0A" : "var(--invict-text-muted)", fontWeight: 700, fontSize: 12, letterSpacing: "0.05em", textTransform: "uppercase", cursor: "pointer", borderBottom: tab === t.k ? "3px solid #BF3437" : "3px solid transparent" }}
            data-testid={`tab-${t.k}`}
          >{t.label}</button>
        ))}
        <div style={{ marginLeft: "auto", alignSelf: "center" }}>
          <ExportButtons kind="services" rows={list} testIdPrefix="svc" filtersLabel={tab === "open" ? "Abiertos" : tab === "closed" ? "Cerrados" : "Todos"} />
        </div>
      </div>

      <div className="card" style={{ padding: 0, overflow: "hidden" }}>
        {list == null && <div style={{ padding: 20 }}><div className="skel" style={{ height: 60 }} /></div>}
        {list && list.length === 0 && <div style={{ padding: 40, textAlign: "center", color: "var(--invict-text-muted)" }}>Sin servicios.</div>}
        {list && list.map((s) => (
          <div key={s.id} style={{ padding: "14px 20px", borderBottom: "1px solid var(--invict-bone-3)", display: "grid", gridTemplateColumns: "2fr 2fr 2fr 1fr auto", gap: 12, alignItems: "center" }} data-testid={`svc-${s.id}`}>
            <div style={{ fontWeight: 800, fontSize: 14 }}>{nameOf(s.client_id)}</div>
            <div style={{ fontSize: 13 }}>{s.supervisor_name}{s.supervisor_deleted && <DeletedUserBadge id={s.id} />}</div>
            <div style={{ fontSize: 11, color: "var(--invict-text-muted)" }}>
              <div>Apertura: {new Date(s.opened_at).toLocaleString("es-AR")}</div>
              {s.closed_at && <div>Cierre: {new Date(s.closed_at).toLocaleString("es-AR")}</div>}
            </div>
            <span className={`badge ${s.status === "open" ? "blue" : "gray"}`}>{s.status === "open" ? "Abierto" : "Cerrado"}</span>
            {s.status === "open" && <button className="btn-ghost" onClick={() => close(s.id)} style={{ padding: "5px 10px", fontSize: 10, color: "#BF3437", borderColor: "#BF3437" }} data-testid={`svc-close-${s.id}`}>Forzar cierre</button>}
          </div>
        ))}
      </div>
    </div>
  );
}
